import React from 'react';
import { Divider } from 'wix-ui-tpa/cssVars';
import { DaySection } from '../../../../shared/components/Agenda/DaySection/DaySection';
import { classes, st } from './Body.st.css';
import { useWidgetViewModel } from '../../hooks/useWidgetViewModel';
import { EmptyState } from '../../../../shared/components/EmptyState/EmptyState';
import { BodyDataHooks } from './const';
import { LoadMoreButton } from '../../../../shared/components/LoadMoreButton/LoadMoreButton';
import { useEnvironment } from '@wix/yoshi-flow-editor';

export const Body: React.FC = () => {
  const { agendaViewModel } = useWidgetViewModel();
  const { days, emptyState } = agendaViewModel || {};
  const { isMobile, isRTL } = useEnvironment();

  const renderDaysSection = () => {
    if (emptyState) {
      return <EmptyState {...emptyState} />;
    }

    return (
      <ul className={st(classes.daysContainer, { isMobile, isRTL })}>
        {days?.map((day) => (
          <li key={day.date}>
            <DaySection {...day} />
            <div className={classes.dayDividerWrapper}>
              <Divider className={classes.dayDivider} />
            </div>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div
      className={st(classes.root, { isRTL, isMobile })}
      data-hook={BodyDataHooks.Main}
    >
      {renderDaysSection()}
      <LoadMoreButton />
    </div>
  );
};
